// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Types
import { AppContextType } from 'contexts/types/app.contexts.type';

const isUploadIdFlowPage = (currentState: AppContextType['currentState']): boolean =>
  [
    AppStatesEnumeration.CHECKOUT_PENDING,
    AppStatesEnumeration.CHECKOUT_PENDING_SCAN_IDS,
    AppStatesEnumeration.CHECKOUT_PENDING_REVIEW,
    AppStatesEnumeration.CHECKOUT_PENDING_REJECTED,
    AppStatesEnumeration.CHECKOUT_PENDING_REJECTED_SCAN_IDS,
    AppStatesEnumeration.CHECKOUT_PENDING_NEEDS_SELFIE,
    AppStatesEnumeration.CHECKOUT_PENDING_BIZUM,
  ].includes(currentState as AppStatesEnumeration);

const isGetStateLoadingPage = (currentState: AppContextType['currentState']): boolean =>
  [AppStatesEnumeration.LOADING].includes(currentState as AppStatesEnumeration);

const isPaymentPage = (currentState: AppContextType['currentState']): boolean =>
  [
    AppStatesEnumeration.CHECKOUT_DOWNPAYMENT,
    AppStatesEnumeration.CHECKOUT_DOWNPAYMENT_PROCESSING,
  ].includes(currentState as AppStatesEnumeration);

const isContractPage = (currentState: AppContextType['currentState']): boolean =>
  [
    AppStatesEnumeration.CHECKOUT_SIGNING,
    AppStatesEnumeration.CHECKOUT_SIGNING_CONTRACTUAL,
    AppStatesEnumeration.CHECKOUT_SIGNING_OTP,
  ].includes(currentState as AppStatesEnumeration);

const isProofOfIncomePage = (currentState: AppContextType['currentState']): boolean =>
  [
    AppStatesEnumeration.CHECKOUT_INCOME,
    AppStatesEnumeration.CHECKOUT_OPENBANKING,
    AppStatesEnumeration.CHECKOUT_WORKLIFE,
  ].includes(currentState as AppStatesEnumeration);

const isKYCFlowPage = (currentState: AppContextType['currentState']): boolean =>
  [
    AppStatesEnumeration.CHECKOUT_IDENTIFICATION,
    AppStatesEnumeration.CHECKOUT_ACCOUNT_CHECK,
    AppStatesEnumeration.CHECKOUT_BIZUM,
    AppStatesEnumeration.CHECKOUT_VIDEOCALL,
  ].includes(currentState as AppStatesEnumeration);

const isThankYouOrPendingPage = (currentState: AppContextType['currentState']): boolean =>
  [
    AppStatesEnumeration.SUCCESS,
    AppStatesEnumeration.CHECKOUT_SIGNED,
    AppStatesEnumeration.CHECKOUT_SIGNED_PENDING,
  ].includes(currentState as AppStatesEnumeration);

const isPendingPage = (currentState: AppContextType['currentState']): boolean =>
  [
    AppStatesEnumeration.CHECKOUT_DOWNPAYMENT_PROCESSING,
    AppStatesEnumeration.CHECKOUT_SIGNED_PENDING,
  ].includes(currentState as AppStatesEnumeration);

const isProcessEndedPage = (currentState: AppContextType['currentState']): boolean =>
  [AppStatesEnumeration.PROCESS_ENDED].includes(currentState as AppStatesEnumeration);

export {
  isContractPage,
  isGetStateLoadingPage,
  isKYCFlowPage,
  isPaymentPage,
  isPendingPage,
  isProcessEndedPage,
  isProofOfIncomePage,
  isThankYouOrPendingPage,
  isUploadIdFlowPage,
};
